(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__productCardSwatchesInit) return;
    window.__productCardSwatchesInit = true;

    var SELECTOR = '.product-card-colors';
    var SWATCH_WIDTH = 30;
    var GAP = 8;
    var MORE_BTN_WIDTH = 30;

    function calculateSwatches(container) {
      var swatches = Array.prototype.slice.call(container.querySelectorAll('.color-swatch-card'));
      var moreBtn = container.querySelector('.show-more-swatches');
      if (!moreBtn || swatches.length === 0) return;

      swatches.forEach(function (s) {
        s.style.display = 'block';
        s.classList.remove('is-hidden-by-js');
      });
      moreBtn.style.display = 'none';

      if (container.dataset.expanded === 'true') return;

      var containerWidth = container.clientWidth;
      if (containerWidth === 0) return; 

      var totalRequired = swatches.length * SWATCH_WIDTH + (swatches.length - 1) * GAP;
      if (totalRequired <= containerWidth) return;

      var maxWidth = containerWidth - MORE_BTN_WIDTH - GAP;
      var currentWidth = 0;
      var visibleCount = 0;

      for (var i = 0; i < swatches.length; i++) {
        var w = SWATCH_WIDTH + (i === 0 ? 0 : GAP);
        if (currentWidth + w <= maxWidth) {
          currentWidth += w;
          visibleCount++;
        } else {
          break;
        }
      }
      if (visibleCount === 0) visibleCount = 1;

      var hiddenCount = swatches.length - visibleCount;
      if (hiddenCount > 0) {
        for (var j = visibleCount; j < swatches.length; j++) {
          swatches[j].style.display = 'none';
          swatches[j].classList.add('is-hidden-by-js');
        }
        var label = '+' + hiddenCount;
        if (moreBtn.textContent !== label) moreBtn.textContent = label;
        moreBtn.style.display = 'flex';
      }
    }

    var queue = new Set();
    var rafId = 0;

    function schedule(container) {
      queue.add(container);
      if (!rafId) rafId = requestAnimationFrame(flush);
    }

    function flush() {
      rafId = 0;
      mo.disconnect();
      queue.forEach(function (c) {
        if (c.isConnected) calculateSwatches(c);
      });
      queue.clear();
      mo.takeRecords();
      startObserving();
    }

    var observed = new WeakSet();
    var ro = 'ResizeObserver' in window
      ? new ResizeObserver(function (entries) {
          entries.forEach(function (entry) { schedule(entry.target); });
        })
      : null;

    function register(container) {
      if (!observed.has(container)) {
        observed.add(container);
        if (ro) ro.observe(container);
      }
      schedule(container);
    }

    function scan(root) {
      if (!root || root.nodeType !== 1) return;
      if (root.matches(SELECTOR)) register(root);
      root.querySelectorAll(SELECTOR).forEach(register);
    }

    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        var target = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        var host = target && target.closest ? target.closest(SELECTOR) : null;
        if (host) register(host);

        if (m.type === 'childList') {
          m.addedNodes.forEach(scan);
        }
      });
    });

    function startObserving() {
      mo.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    function init() {
      scan(document.body);
      startObserving();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    if (!ro) {
      window.addEventListener('resize', function () {
        document.querySelectorAll(SELECTOR).forEach(schedule);
      });
    }

    document.addEventListener('shopify:section:load', function (e) {
      scan(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__videoSoundPauseInit) return;
    window.__videoSoundPauseInit = true;

    function getToggle(media) {
      return media ? media.querySelector('[data-video-sound-toggle]') : null;
    }

    function syncToggle(video) {
      var media = video.closest('deferred-media');
      var btn = getToggle(media);
      if (!btn) return;
      var soundOn = !video.muted && video.volume > 0;
      btn.hidden = false;
      btn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
      btn.setAttribute('aria-label', soundOn ? 'Вимкнути звук' : 'Увімкнути звук');
    }

    // Показуємо кнопку звуку, щойно відео почало грати; синхронізуємо іконку
    document.addEventListener('play', function (e) {
      if (e.target instanceof HTMLVideoElement) syncToggle(e.target);
    }, true);
    document.addEventListener('volumechange', function (e) {
      if (e.target instanceof HTMLVideoElement) syncToggle(e.target);
    }, true);

    // Клік по кнопці звуку — не пускаємо далі (щоб не відкривався зум / не спрацьовував play-pause)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-video-sound-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var video = btn.closest('deferred-media') && btn.closest('deferred-media').querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      if (!video.muted && video.volume === 0) video.volume = 1;
      if (video.paused) video.play().catch(function () {});
      syncToggle(video);
    }, true);

    // ===== Пауза, коли відео зникає з екрана (перегортання слайда, скрол, закриття зуму) =====
    function pauseIn(media) {
      var paused = false;
      media.querySelectorAll('video').forEach(function (v) {
        if (!v.paused) { v.pause(); paused = true; }
      });
      media.querySelectorAll('iframe').forEach(function (f) {
        var src = f.getAttribute('src') || '';
        try {
          if (/youtube/i.test(src)) {
            f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }), '*');
            paused = true;
          } else if (/vimeo/i.test(src)) {
            f.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
            paused = true;
          }
        } catch (err) {}
      });
      if (paused) media.dataset.autoPaused = 'true';
    }

    function resumeIn(media) {
      // Відновлюємо лише відео з автоплеєм, яке ми самі поставили на паузу
      if (media.dataset.autoPaused !== 'true' || !media.hasAttribute('autoplay')) return;
      delete media.dataset.autoPaused;
      media.querySelectorAll('video').forEach(function (v) {
        if (v.paused) v.play().catch(function () {});
      });
      media.querySelectorAll('iframe').forEach(function (f) {
        var src = f.getAttribute('src') || '';
        try {
          if (/youtube/i.test(src)) f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: '' }), '*');
          else if (/vimeo/i.test(src)) f.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
        } catch (err) {}
      });
    }

    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio < 0.5) pauseIn(entry.target);
        else resumeIn(entry.target);
      });
    }, { threshold: [0, 0.5] });

    var observed = new WeakSet();
    function observeAll(root) {
      (root || document).querySelectorAll('deferred-media').forEach(function (m) {
        if (observed.has(m)) return;
        observed.add(m);
        io.observe(m);
      });
    }

    function start() {
      observeAll(document);
      // Нові галереї (quick-add, зміна варіанту, перерендер секції)
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { observeAll(document); }, 100);
      }).observe(document.body, { childList: true, subtree: true });
    }

    // Вкладка прихована — теж пауза
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) document.querySelectorAll('deferred-media').forEach(pauseIn);
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
